import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Dry", value: 4, fill: "#A6CEE3" },
  { name: "Wet", value: 2.5, fill: "#B2DF8A" },
  { name: "Domestic Hazardous", value: 3.5, fill: "#BEBADA" },
  { name: "Mixed", value: 4.2, fill: "#FDBF6F" },
];

const BarChartComponent: React.FC = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} maxBarSize={50}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis domain={[0, 5]} />
        <Tooltip />
        <Legend />
        <Bar  dataKey="value" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
